import { useTitle } from 'ahooks';

import { Loader } from 'components/loader';
import './FullscreenSpinner.scss';

const FullscreenSpinner = ({ children }: { children?: JSX.Element }) => {
  useTitle('Loading - NightOwl');
  return (
    <div className="fullscreenspinner">
      <div className="loader-holder">{children || <Loader />}</div>
    </div>
  );
};

export default FullscreenSpinner;
